import {
  OEButton,
  OEModal,
  OEText,
  ChangePasswordForm,
  BackButton,
} from '@openeducation/oe-it-components';
import { teacherProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { styled } from '@openeducation/oe-it-themes';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import * as yup from 'yup';

import { useTeacherProfile } from '../../hooks/use-teacher-profile';

export interface ChangePasswordModalProps {
  goBack: () => void;
}

const formSchema = yup.object().shape({
  currentPassword: yup.string().required('Current password is required'),
  password: yup
    .string()
    .required('New Password is required')
    .min(6, 'Password length should be at least 6 characters'),
  confirmPassword: yup
    .string()
    .required('Confirm Password is required')
    .oneOf([yup.ref('password')], 'Passwords do not match'),
});

export const ChangePasswordModal = ({ goBack }: ChangePasswordModalProps) => {
  const [success, setSuccess] = useState(false);
  const teacherProfile = useAtomValue(teacherProfileAtom);
  const {
    changePassword,
    isChangePasswordLoading,
    errorChangePassword,
    isChangePasswordSuccess,
    resetChangePassword,
  } = useTeacherProfile();

  useEffect(() => {
    if (isChangePasswordSuccess) {
      setSuccess(true);
    }
  }, [isChangePasswordSuccess]);

  const handleSubmit = (data: {
    password: string;
    currentPassword: string;
  }) => {
    if (teacherProfile?.accountName) {
      changePassword({
        ...data,
        accountName: teacherProfile?.accountName,
        teacherId: teacherProfile?.id,
      });
    }
  };

  if (success) {
    return (
      <MessageContainer visible>
        <Header>
          <Title>Password successfully changed!</Title>
        </Header>
        <StyledButton onPress={goBack}>Go back</StyledButton>
      </MessageContainer>
    );
  }

  return (
    <Container onClose={goBack} visible>
      <Header>
        <BackButton onPress={goBack} size={16} />
        <Title>Change Password</Title>
      </Header>

      <ChangePasswordForm
        labels={{
          currentPasswordLabel: 'Current password',
          newPasswordLabel: 'New Password',
          confirmPasswordLabel: 'Confirm Password',
          buttonSubmit: 'Update Password',
        }}
        isLoading={isChangePasswordLoading}
        onSubmit={handleSubmit}
        onResetValidation={resetChangePassword}
        errorMessage={errorChangePassword?.message}
        formSchema={formSchema}
      />
    </Container>
  );
};

const Container = styled(OEModal)`
  width: 600px;
  padding: 40px;
`;
const MessageContainer = styled(OEModal)`
  width: 420px;
  padding: 40px;
`;
const Title = styled(OEText).attrs({
  fontType: 'bold',
  fontSize: 20,
})`
  text-align: center;
  width: 100%;
`;
const StyledButton = styled(OEButton)`
  flex: auto;
  align-self: flex-end;
  margin-top: 22px;
`;
const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
